import React, { useState } from 'react'
import DropDown from '../Partials/DropDown';
import { useStateContext } from '../../Providers/ContextProvider';
import { useParams } from "react-router-dom"
import BlogPost from './BlogPost';
import { useNavigate } from 'react-router-dom';
import SideBar from '../Partials/SideBar';

function Blog() {
    const [showlists, setShowlists] = useState([false, false]);
    const { setSelectedItems, selectedItems } = useStateContext();
    const { blogId } = useParams();
    const navigate = useNavigate();

    const toggleDropDown = (index) => {
        const newShowLists = [...showlists];
        newShowLists[index] = !newShowLists[index];
        setShowlists(newShowLists);
    }

    const handleSelect = () => { };

    const links = [
        { url: '#home', text: 'Home' },
        { url: '#about', text: 'About' },
        { url: '#services', text: 'Services' },
        { url: '#contact', text: 'Contact' },
    ];


    const handleClick = () => {
        navigate(-1);
    };

    return (
        <>
            <div className="flex flex-col px-5 mt-20">
                {blogId ? (
                    <button onClick={handleClick} className="flex flex-row self-start items-center gap-2 text-base text-right text-zinc-900 max-md:flex-wrap max-md:pl-5 max-md:max-w-full">
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/bf5ebe68718414aa09032adc1faa72bfc5b65e67fd3efb0465b740e24356ce36?"
                            className="flex-1 shrink-0 h-[20px] aspect-square"
                        />
                        <div className="grow">عودة </div>
                    </button>
                ) : (
                    <div className="self-start text-5xl font-bold text-right text-zinc-900">
                        المدونة
                    </div>
                )}
                <div className="mt-7 w-full max-md:max-w-full">
                    <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                        {blogId ? (<BlogPost />) : (
                            <div className="flex flex-col ml-5 w-[67%] max-md:ml-0 max-md:w-full">
                                <div className="flex flex-col grow max-md:mt-6 max-md:max-w-full">
                                    <div className="flex flex-col px-2 pt-8 pb-2 bg-white rounded-2xl max-md:max-w-full">
                                        <div className="flex gap-5 justify-between mx-4 text-xl font-light text-right text-black max-md:flex-wrap max-md:mr-2.5 max-md:max-w-full">
                                            <img
                                                loading="lazy"
                                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/6e46e9a087bcdbff985f89bd5f6c19fc1853ba2112f213f0ba23516d1bf137ae?"
                                                className="w-9 aspect-square"
                                            />
                                            <input className="flex-auto my-auto max-md:max-w-full outline-none text-black"
                                                placeholder='عن مقال داخل المدونة او قم بعمل تصفية وفرز'
                                            />
                                            <button className="justify-center px-5 py-2.5 text-base font-bold text-center text-white whitespace-nowrap bg-blue-900 rounded-lg shadow-sm">
                                                بحث
                                            </button>
                                        </div>
                                        <div className="flex flex-col justify-center px-4 py-5 mt-8 bg-white bg-opacity-70 max-md:max-w-full">
                                            <div className="flex gap-5 justify-between px-1.5 py-1 w-full max-md:flex-wrap max-md:max-w-full">
                                                <div className="flex gap-5 text-base font-semibold text-center text-black whitespace-nowrap max-md:flex-wrap max-md:max-w-full">
                                                    <button className="relative flex gap-2 justify-between px-5 py-2.5 rounded-xl border border-gray-200 border-solid"
                                                        onClick={() => toggleDropDown(0)}
                                                    >
                                                        <img
                                                            loading="lazy"
                                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/fb7ee6ff94730c90c98c4a099d1f2cb2832f51627f858ba2d8f597d5673c6e12?"
                                                            className="w-6 aspect-square"
                                                        />
                                                        <div>فلتر</div>
                                                        <DropDown links={links} onSelect={(value) => handleSelect(value, 0)} isOpen={showlists[0]} dropdownId={0} />
                                                    </button>
                                                    <button className="relative flex gap-2 justify-between px-5 py-2.5 rounded-xl border border-gray-200 border-solid"
                                                        onClick={() => toggleDropDown(1)}
                                                    >
                                                        <img
                                                            loading="lazy"
                                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/1029da3c07f4efffac5db86b48e746b7f95da00c532a5bf8ee91fc5e00081303?"
                                                            className="w-6 aspect-square"
                                                        />
                                                        <div>تصنيف</div>
                                                        <DropDown links={links} onSelect={(value) => handleSelect(value, 0)} isOpen={showlists[1]} dropdownId={1} />
                                                    </button>
                                                    {selectedItems.length > 0 &&
                                                        <div className="flex gap-2 justify-between px-5 py-2.5 font-bold bg-amber-300 rounded-xl">
                                                            <img onClick={() => setSelectedItems([])}
                                                                loading="lazy"
                                                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/e6e5d75473811092c17de9e320447a7ccef2e12b5cc08e57a3df34dc59b87aee?"
                                                                className="w-6 aspect-square hover:cursor-pointer"
                                                            />
                                                            <div className="grow">ترتيب حسب: {selectedItems.join(', ')}</div>
                                                        </div>
                                                    }
                                                </div>
                                                <button onClick={() => setSelectedItems([])} className="my-auto text-base font-light leading-8 text-right text-zinc-900">
                                                    حذف الجميع
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-10 max-md:max-w-full">
                                        <div className="grid grid-cols-2 gap-5 max-md:grid-cols-1 max-md:gap-0">
                                            <div className="flex flex-col max-md:ml-0 max-md:w-full">
                                                <div className="flex grow gap-1 justify-between p-2 w-full bg-white rounded-2xl border border-solid border-zinc-300 max-md:mt-5">
                                                    <div className="flex overflow-hidden relative flex-col items-start pt-3 pr-3 pb-12 pl-16 text-sm font-medium tracking-normal leading-3 text-center text-pink-800 uppercase whitespace-nowrap rounded-xl aspect-[1.22] w-[183px] max-md:pl-5">
                                                        <img
                                                            loading="lazy"
                                                            srcSet="https://www.riyadhenv.gov.sa/wp-content/uploads/2016/12/DSC_0049.jpg"
                                                            className="object-cover absolute inset-0 size-full"
                                                        />
                                                        <div className="relative justify-center px-2.5 py-1 bg-red-100 rounded-xl border-pink-800 border-solid aspect-[2.61] border-[0.5px]">
                                                            صحة
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col flex-1 justify-center px-4 py-1.5 text-right bg-white bg-opacity-70">
                                                        <div className="text-lg font-bold text-zinc-900">
                                                            انتشال أحياء في درنة والمساعدات الدولية تتدفق على
                                                            ليبيا
                                                            <br />
                                                        </div>
                                                        <div className="self-start mt-3 text-sm whitespace-nowrap text-stone-900">
                                                            18 April 2023
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-col max-md:ml-0 max-md:w-full">
                                                <div className="flex grow gap-1 justify-between p-2 w-full bg-white rounded-2xl border border-solid border-zinc-300 max-md:mt-5">
                                                    <div className="flex overflow-hidden relative flex-col items-start pt-3 pr-3 pb-12 pl-16 text-sm font-medium tracking-normal leading-3 text-center text-pink-800 uppercase whitespace-nowrap rounded-xl aspect-[1.22] w-[183px] max-md:pl-5">
                                                        <img
                                                            loading="lazy"
                                                            srcSet="https://www.riyadhenv.gov.sa/wp-content/uploads/2016/12/DSC_0049.jpg"
                                                            className="object-cover absolute inset-0 size-full"
                                                        />
                                                        <div className="relative justify-center px-2.5 py-1 bg-red-100 rounded-xl border-pink-800 border-solid aspect-[2.61] border-[0.5px]">
                                                            صحة
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col flex-1 justify-center px-4 py-1.5 text-right bg-white bg-opacity-70">
                                                        <div className="text-lg font-bold text-zinc-900">
                                                            انتشال أحياء في درنة والمساعدات الدولية تتدفق على
                                                            ليبيا
                                                            <br />
                                                        </div>
                                                        <div className="self-start mt-3 text-sm whitespace-nowrap text-stone-900">
                                                            18 April 2023
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="max-md:text-center justify-center self-center px-5 py-2.5 mt-10 text-base font-semibold text-center text-black whitespace-nowrap rounded-lg border border-black border-solid shadow-sm">
                                    تحميل المزيد
                                </div>
                            </div>
                        )}
                        <SideBar />
                    </div>
                </div>

            </div>
        </>
    )
}

export default Blog